import { ConfigService } from 'app/app-config.service';
import { CustomTranslateService } from './../../../main/services/common/custom-translate.service';
import { Component } from '@angular/core';

@Component({
    selector: 'app-faq',
    templateUrl: './faq.component.html',
    styleUrls: ['./faq.component.scss'],
    standalone: false,
})
export class FaqComponent {
    public dCarbonizeMail: string;
    constructor(
        private configService: ConfigService,
        private readonly translateService: CustomTranslateService,
    ) {
        this.dCarbonizeMail = this.configService.getClient.support?.mailDcarbonize ?? '';
    }

    private readonly data: { name: string; answer: string }[] = [
        { name: 'menu.modals.needHelp.faq.question1.name', answer: 'menu.modals.needHelp.faq.question1.answer' },
        { name: 'menu.modals.needHelp.faq.question2.name', answer: 'menu.modals.needHelp.faq.question2.answer' },
        { name: 'menu.modals.needHelp.faq.question3.name', answer: 'menu.modals.needHelp.faq.question3.answer' },
        { name: 'menu.modals.needHelp.faq.question4.name', answer: 'menu.modals.needHelp.faq.question4.answer' },
        { name: 'menu.modals.needHelp.faq.question5.name', answer: 'menu.modals.needHelp.faq.question5.answer' },
        { name: 'menu.modals.needHelp.faq.question6.name', answer: 'menu.modals.needHelp.faq.question6.answer' },
        { name: 'menu.modals.needHelp.faq.question7.name', answer: 'menu.modals.needHelp.faq.question7.answer' },
        { name: 'menu.modals.needHelp.faq.question8.name', answer: 'menu.modals.needHelp.faq.question8.answer' },
        { name: 'menu.modals.needHelp.faq.question9.name', answer: 'menu.modals.needHelp.faq.question9.answer' },
        { name: 'menu.modals.needHelp.faq.question10.name', answer: 'menu.modals.needHelp.faq.question10.answer' },
        { name: 'menu.modals.needHelp.faq.question11.name', answer: 'menu.modals.needHelp.faq.question11.answer' },
        { name: 'menu.modals.needHelp.faq.question12.name', answer: 'menu.modals.needHelp.faq.question12.answer' },
        { name: 'menu.modals.needHelp.faq.question13.name', answer: 'menu.modals.needHelp.faq.question13.answer' },
        { name: 'menu.modals.needHelp.faq.question14.name', answer: 'menu.modals.needHelp.faq.question14.answer' },
        { name: 'menu.modals.needHelp.faq.question15.name', answer: 'menu.modals.needHelp.faq.question15.answer' },
        { name: 'menu.modals.needHelp.faq.question16.name', answer: 'menu.modals.needHelp.faq.question16.answer' },
        { name: 'menu.modals.needHelp.faq.question17.name', answer: 'menu.modals.needHelp.faq.question17.answer' },
        { name: 'menu.modals.needHelp.faq.question18.name', answer: 'menu.modals.needHelp.faq.question18.answer' },
        { name: 'menu.modals.needHelp.faq.question19.name', answer: 'menu.modals.needHelp.faq.question19.answer' },
    ];

    faq = this.data;
    onSearch(value: string) {
        if (value.trim() !== '') {
            const translationPromises = this.data.map((elt) => {
                return this.translateService
                    .get(elt.name)
                    .toPromise()
                    .then((translatedLabel: string | undefined) => {
                        const label: string =
                            (Array.isArray(translatedLabel) ? (translatedLabel as string[])[0] : translatedLabel) ?? '';
                        return { ...elt, translatedLabel: label };
                    });
            });

            Promise.all(translationPromises).then((translatedValues) => {
                this.faq = translatedValues.filter((elt) =>
                    elt.translatedLabel.toLowerCase().replace(/[‘’]/g, '’').includes(value.toLowerCase()),
                );
            });
        } else {
            this.faq = this.data;
        }
    }
    onClickCantFindQuestion() {
        this.translateService.get('menu.modals.needHelp.faq.content.subject').subscribe((subject) => {
            const mail = `mailto:${this.dCarbonizeMail}?&subject=${subject}`;
            window.open(mail, 'emailWindow');
        });
    }
}
